/**
 * Created by Gary.zhou on 2017/3/28.
 */
import Vue from 'vue';
import Api from 'cnfapi';
import conf from './config';
import apiLists from './apiLists';
import { getSha256 } from './lib/js-sha256';

const { sha256 } = getSha256();

const { BASE_URL, apiKey, apiSecret, ticketErrCode } = conf;

const vsApi = new Api({
  baseURL: BASE_URL,
  env: 'browser',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: conf.timeout,
  resSuccessCallback(data, next) {
    // next接受3个参数
    // 第一个参数是代表error
    // 第二个参数是代表传递给 resolve 的数据
    // 第三个参数是自定义数据
    if (data.code === 200) {
      next(null, data.data, data.code);
    } else {
      next({
        msg: data.msg,
        retcode: data.code,
      }, {}, data.code);
    }
  },
  openResInterceptor(res) {
    return ticketErrCode.includes(+res.code);
  },
  resInterceptor() {
    return false;
  },
}, apiLists);

vsApi._before = function _before(apiOpts, apiConf, next) {
  console.log('_before===',apiOpts, apiConf, next)
  let signData = {};
  let { data } = apiOpts;
  if (!data || typeof data !== 'object') {
    data = {};
  }
  const _keysSort = getParamsSort(apiConf);
  if (!_keysSort) {
    signData = { ...data };
  } else {
    _keysSort.forEach(key => {
      signData[key] = data[key];
    });
  }
  data.app_key = apiKey;
  data.sign = getSignurature(signData);
  apiOpts.data = data;
  apiConf.headers["Authorization-AppKey"] = apiKey;
  apiConf.headers["Authorization-Sign"] = data.sign;
  apiConf.headers["Authorization-Token"] = data.ticket ? data.ticket : "";
  next(apiOpts);
};

function getParamsSort(apiConfig) {
  if (!apiConfig || !apiConfig.params) return null;
  if (typeof apiConfig.params !== 'object') return null;
  let _params = null;
  if (apiConfig.params.post) _params = apiConfig.params.post;
  if (apiConfig.params.get) _params = apiConfig.params.get;
  if (!_params) return null;
  return _params.map(item => item.param);
}

function getSignurature(signData) {
  const _token = signData.ticket || '';
  const string = apiKey + JSON.stringify(signData) + _token + apiSecret;
  return sha256(string);
}

vsApi.install = function(Vue, options = {}) {
  Vue.prototype.vsApi = vsApi;
};
Vue.use(vsApi);
window.vsApi = vsApi;
window.httpWrap = async function(promise){
  return new Promise(resole=>{
    promise.then(res=>{
      resole([null,res])
    }).catch(e=>{
      resole([e,null])
    })
  })
}

export default vsApi;
